import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'

import { Button, Form, Modal } from '_zari/core'

import * as PresupuestoService from 'services/presupuesto.service'

import * as FormGroups from './formGroups'
import ValidationSchema from './validation'

const NuevoPresupuestoModal = ({ handleClose, show, refreshTreeView, modalData }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(
    () => ({
      datoPresupuestoNivel1: modalData.datoPresupuestoNivel1 ?? '',
      datoPresupuestoNivel2: modalData.datoPresupuestoNivel2 ?? '',
      datoPresupuestoNivel3: ''
    }),
    [modalData]
  )

  const submitHandler = (data, { setSubmitting }) => {
    PresupuestoService.nuevo(data)
      .then(() => {
        __zariContext.snack('success', 'El registro se ha creado.')
        refreshTreeView()
        handleClose()
      })
      .catch(({ data: { error } }) => {
        __zariContext.snack('error', error)
        setSubmitting(false)
      })
  }

  return (
    <Modal show={show} onHide={handleClose} size='sm'>
      <Modal.Header>
        <Modal.Title>NUEVO PRESUPUESTO</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={submitHandler} validationSchema={ValidationSchema}>
        {({ errors, handleSubmit, isSubmitting, touched, values, setFieldValue, setValues }) => (
          <Form>
            <Modal.Body>
              <FormGroups.DatoPresupuestoNivel1FormGroup
                iError={errors.datoPresupuestoNivel1}
                iTouched={touched.datoPresupuestoNivel1}
                fIsSubmitting={isSubmitting || modalData.nivelBloqueo <= 2}
                setFieldValue={setFieldValue}
              />
              <FormGroups.DatoPresupuestoNivel2FormGroup
                iError={errors.datoPresupuestoNivel2}
                iTouched={touched.datoPresupuestoNivel2}
                fIsSubmitting={isSubmitting || modalData.nivelBloqueo === 2}
                setFieldValue={setFieldValue}
              />
              <FormGroups.DatoPresupuestoNivel3FormGroup
                iError={errors.datoPresupuestoNivel3}
                iTouched={touched.datoPresupuestoNivel3}
                fIsSubmitting={isSubmitting}
                setFieldValue={setFieldValue}
              />
            </Modal.Body>
            <Modal.Footer>
              <Button color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button onClick={handleSubmit}>Crear</Button>
            </Modal.Footer>
          </Form>
        )}
      </Formik>
    </Modal>
  )
}

export default NuevoPresupuestoModal
